import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import Expandable from "./Expandable";
import Tag from "./Tag";
import { getIcon } from "../utils/icons";

interface ProjectCardProps {
  title: string;
  description: string;
  image?: string;
  url?: string;
  icon?: React.ReactElement;
  keywords?: string[];
  forceExpanded?: boolean;
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  title,
  description,
  image,
  url,
  icon,
  keywords,
  forceExpanded,
}) => {
  const CardContent = (
    <div className="bg-gray-800 rounded-lg overflow-hidden hover:bg-gray-750 transition-colors">
      {image && (
        <div className="h-40 bg-gray-700 flex items-center justify-center overflow-hidden">
          <img src={image} alt={title} className="w-full h-full object-cover" />
        </div>
      )}
      <div className="p-4">
        <Expandable
          header={
            <div className="flex items-start space-x-3">
              {icon && <div className="text-2xl mt-1">{icon}</div>}
              <div>
                <h3 className="text-lg font-semibold mb-2">{title}</h3>
                <p className="text-gray-400 text-sm">{description}</p>
              </div>
            </div>
          }
          defaultExpanded={false}
          forceExpanded={forceExpanded}
        >
          {keywords && keywords.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {keywords.map((keyword) => (
                <Tag
                  key={keyword}
                  name={keyword}
                  icon={getIcon(keyword, { size: 14 })}
                  className="bg-gray-700 text-white border border-gray-600"
                />
              ))}
            </div>
          )}
        </Expandable>

        {url && (
          <div className="mt-3 flex justify-end">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                e.stopPropagation();
              }}
              className="inline-flex items-center text-sm text-sky-400 hover:text-sky-300"
            >
              Visit
              <FaExternalLinkAlt className="ml-2" size={12} />
            </a>
          </div>
        )}
      </div>
    </div>
  );

  return CardContent;
};

export default ProjectCard;
